import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from '../../../app.constants';
import { ParentService } from '../ParentClass/ParentService';


@Injectable()
export class ValidateVINService extends ParentService {

  constructor(private _http: Http) {
      super();
  }

  /**
   * @name getVIN
   * @description
   * @param speech
   */
  getVIN(speech: any) {
    return this._http
      .get(constant.URL_VEHICLE_VIN + '?VIN=' + speech, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getMakes
   * @description
   */
  getMakes() {
    return this._http
      .get(constant.URL_VEHICLE_MAKES, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getModels
   * @description
   * @param event
   */
  getModels(event) {
    return this._http
      .get(constant.URL_VEHICLE_MODELS + '?make=' + event, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getModels
   * @description
   * @param make
   */
  getModels2(make: string) {
    return this._http
      .get(`${constant.URL_VEHICLE_MODELS}?newApi=true&make=${make}`, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getYears
   * @description
   * @param eventMake
   * @param eventModel
   */
  getYears(eventMake, eventModel) {
    return this._http
      .get(constant.URL_VEHICLE_YEARS + '?make=' + eventMake + '&model=' + eventModel, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getOnyMakes
   * @description
   */
  getOnyMakes(api: boolean) {
    return this._http
      .get(`${constant.URL_VEHICLE_ONLY_MAKES}?newApi=${api}`, this.getHeader())
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/validate-vin/validate-vin.service.ts